"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AGGREGATED_PRODUCT_MEASURE_UNITS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_AGGREGATED_PRODUCT_MEASURE_UNITS = (0, gql_1.gql)(`
  query AggregatedProductMeasureUnits(
    $productTreeNodeId: ID!,
    $dimension: String!,
    $catalog: ID!,
    $filter: ProductAggregatedMeasureUnitListFilter,
    $sort: [ProductAggregatedMeasureUnitOrderBy!],
    $first: Int,
    $last: Int,
    $before: ID,
    $after: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productAggregatedMeasures(
        catalog: $catalog,
        filter: { some: { dimension: { equals: $dimension } } },
        first: 1,
      ) {
        edges {
          node {
            dimension
            units(
              filter: $filter,
              sort: $sort,
              first: $first,
              last: $last,
              before: $before,
              after: $after,
            ) {
              edges {
                node {
                  productCount
                  unit
                  values {
                    edges {
                      node {
                        value
                        productCount
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                startCursor
                endCursor
              }
            }
          }
        }
      }
    }
  }
`);
